import { render, staticRenderFns } from "./reo-market-product-matrix.vue?vue&type=template&id=2484f789&scoped=true&"
import script from "./reo-market-product-matrix.vue?vue&type=script&lang=js&"
export * from "./reo-market-product-matrix.vue?vue&type=script&lang=js&"
import style0 from "./reo-market-product-matrix.vue?vue&type=style&index=0&id=2484f789&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2484f789",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VIcon,VRow,VTooltip})
